import { ReactElement } from 'react'
import { MockedResponse } from '@apollo/client/testing'
import { render } from '@testing-library/react'
import { IntlProvider } from 'react-intl'

import { FlagProvider, flagsAllEnabled, flattenMessages, getMessages, Locales } from '@acre/utils'
import { muiTheme, ThemeProvider } from '@acre/design-system'

import MockedProvider from './MockedProvider'

const flattenedMessages = flattenMessages(getMessages('broker-crm', Locales.GB))

export default (tree: ReactElement, mocks?: MockedResponse<Record<string, any>>[]) => {
  const children = mocks ? <MockedProvider mocks={mocks}>{tree}</MockedProvider> : tree

  return render(
    <FlagProvider value={flagsAllEnabled}>
      <IntlProvider locale={Locales.GB} messages={flattenedMessages}>
        <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
      </IntlProvider>
    </FlagProvider>,
  )
}
